import { NgFor } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-faq',
  imports: [NgFor],
  templateUrl: './faq.html',
  styleUrl: './faq.css',
})
export class Faq {
  expandedIndex: number | null = 0;

  readonly faqs = [
    {
      question: 'What kind of communication do I get?',
      answer:
        'You will have your own dedicated communication channel with direct access to the team. We also recommend regular check-ins to review performance, priorities, and overall strategy.',
    },
    {
      question: 'How involved is Tricore after launch?',
      answer:
        'We stay actively involved after launch through growth planning, operations support, testing, and data-led optimisation so the venture can scale with structure.',
    },
    {
      question: 'What kind of ventures do you work on?',
      answer:
        'We focus on digital-first businesses with strong long-term potential, especially across technology, media, commerce, education, and adjacent growth sectors.',
    },
    {
      question: 'How do you evaluate new opportunities?',
      answer:
        'We look at market size, urgency of the problem, defensibility, scalability, and whether the opportunity fits our execution model and strategic direction.',
    },
    {
      question: 'Can founders or partners collaborate with you?',
      answer:
        'Yes. If your business or idea aligns with our focus, you can reach out through the contact page and our team will review the opportunity with you.',
    },
    {
      question: 'Do you only invest, or do you also operate?',
      answer:
        'We do both. Tricore combines strategic investment with hands-on operating support so ventures can move faster with shared expertise and infrastructure.',
    },
    {
      question: 'What does the venture build process look like?',
      answer:
        'We begin with research and validation, move into product and go-to-market execution, then scale using clear milestones, systems, and performance tracking.',
    },
    {
      question: 'Where is Tricore based?',
      answer:
        'We are headquartered in Pakistan and collaborate with partners and clients across the region.',
    },
    {
      question: 'How do you evaluate new opportunities?',
      answer:
        'We assess problem severity, market size, competitive landscape, and the ability to create a defensible advantage.',
    },
    {
      question: 'Do you hire for your ventures?',
      answer:
        'Yes. We recruit across product, engineering, growth, and operations. Reach out for current openings.',
    },
    {
      question: 'How do you handle data and privacy?',
      answer:
        'We follow strict security practices and only collect the information necessary to support collaboration and operations.',
    },
  ];

  toggleFaq(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }
}
